import { useEffect, useState } from 'react';
import { prop, props, any, isNil } from 'ramda';
import VerifyLateEditTokenMutation from '../_graphql/mutations/tokens/VerifyLateEditTokenMutation';
import { decodeJwtSafely, isJwtExpired } from '../utils/jwt';

const useTokenValidation = (location) => {
  const [isValid, setIsValid] = useState(null);
  const [token, setToken] = useState(undefined);
  const [documentId, setDocumentId] = useState(undefined);
  const [externalId, setExternalId] = useState(undefined);

  useEffect(() => {
    const params = new URLSearchParams(prop('search', location));
    const token = params.get('token');

    if (!token) {
      setIsValid(false);
      return;
    }

    setToken(token);
    const decoded = decodeJwtSafely(token);
    if (isJwtExpired(decoded)) {
      setIsValid(false);
      return;
    }

    const [apiKey, externalId, documentId] = props(['apiKey', 'externalId', 'documentId'], decoded);
    const anyFieldMissing = any(isNil, [apiKey, externalId, documentId]);
    if (anyFieldMissing) {
      setIsValid(false);
      return;
    }

    setDocumentId(documentId);
    setExternalId(externalId);
  }, [location]);

  useEffect(() => {
    if (token && documentId && externalId) {
      VerifyLateEditTokenMutation(token, externalId, documentId, (ok) => setIsValid(ok));
    }
  }, [token, documentId, externalId]);

  return {
    isValid, token, documentId, externalId
  };
};

export default useTokenValidation;
